import { useState } from 'react';
import ConversationTemplatePicker from '../../students/ConversationTemplatePicker';
import ContainerConfigForm from '../../../components/ContainerConfigForm';
import { getContainerLayoutType } from '../../../variables/containerLayoutTypes';
import { parseEmbedLayoutConfig, EMBED_DISPLAY_MODES } from '../../../variables/embedConversationLayout';

// Thin wrapper around the existing student-card conversation picker -
// reused as-is (same value/onChange/placeholder contract), just adapted to
// the block editor's onSave(changes)/onCancel contract. Writes the
// `conversation` relation, plus a display config for how the walked
// question sequence renders in Preview: either spatially arranged all at
// once (reuses the exact same ContainerConfigForm/4-layout-kind picker the
// Topic/Exercise containers use) or as a one-question-at-a-time stepper
// (no further config needed - see variables/embedConversationLayout.js for
// why no new backend field is needed either way). Everything is staged
// locally and only sent together on save, matching this editor's existing
// pattern (no autosave per keystroke).
export default function EmbedConversationPicker({ block, onSave, onCancel }) {
   const [conversationId, setConversationId] = useState(block.conversation ? String(block.conversation.id) : '');
   const [layoutConfig, setLayoutConfig] = useState(() => parseEmbedLayoutConfig(block.config));
   const displayMode = layoutConfig.displayMode || 'layout';

   const handleSave = () => onSave({ conversation: conversationId, config: JSON.stringify(layoutConfig) });

   const handleModeChange = (mode) => setLayoutConfig((prev) => ({ ...prev, displayMode: mode }));

   const handleLayoutChange = (newLayout) => {
      const newType = getContainerLayoutType(newLayout);
      setLayoutConfig({ ...layoutConfig, layout: newLayout, ...newType.defaultConfig });
   };

   return (
      <div className='exercise-block-embed-editor'>
         <ConversationTemplatePicker value={conversationId} onChange={setConversationId} placeholder='Обрати існуючий тест...' />
         <div className='topic-container-layout-picker'>
            {EMBED_DISPLAY_MODES.map((m) => (
               <div key={m.key} className={'topic-container-layout-chip' + (displayMode === m.key ? ' active' : '')}
                  onClick={() => handleModeChange(m.key)}>
                  {m.label}
               </div>
            ))}
         </div>
         {displayMode === 'layout' ? (
            <ContainerConfigForm layoutKey={layoutConfig.layout} config={layoutConfig}
               onLayoutChange={handleLayoutChange} onConfigChange={setLayoutConfig} />
         ) : ''}
         <div className='exercise-block-editor-actions'>
            <button type='button' className='exercise-block-save-btn' onClick={handleSave}>Зберегти</button>
            <button type='button' className='exercise-block-cancel-btn' onClick={onCancel}>Скасувати</button>
         </div>
      </div>
   );
}

export function renderEmbedConversationPreview(block) {
   if(!block.conversation) return <span className='exercise-block-empty-hint'>Тест не обрано</span>;
   return <div className='exercise-block-embed-preview'>📋 {block.conversation.name}</div>;
}
